import { useMemo } from 'react';

import type { SearchFrameConfig } from 'bundles/search-common/components/SearchFrame';
import { FILTER_TYPE, PAGINATION_TYPE } from 'bundles/search-common/constants/filter';

type UseSearchFrameSeoConfigParams = {
  isSEOEntityPage: boolean;
};

/**
 * Custom hook for SEO entity page SearchFrame configuration
 * Provides consistent configuration for search frames in SEO entity pages
 *
 * @param params - Configuration parameters
 * @param params.isSEOEntityPage - Whether this is an SEO entity page with search query
 * @returns SearchFrame configuration object
 */
export const useSearchFrameSeoConfig = ({ isSEOEntityPage }: UseSearchFrameSeoConfigParams): SearchFrameConfig => {
  return useMemo(
    () => ({
      paginationType: PAGINATION_TYPE.PAGINATED,
      filterType: FILTER_TYPE.EXPANDABLE,
      showSortBy: true,
      showRelatedQueries: true,
      isSEOEntityPage,
      enableFilters: true,
      enableFeaturedSnippet: true,
      enableSchemaMarkup: true,
      enableSEOMetatags: true,
      showResultsHeader: true,
    }),
    [isSEOEntityPage]
  );
};

export default useSearchFrameSeoConfig;
